/**
 * Boolean que indica se a coleta de métricas (sentry, firebase etc) deve ser habilitada.
 * Deve ser true apenas para servidores de `prod` e `staging`
 */
export const METRICS_ENABLED =
  process.env.NODE_ENV === 'production' &&
  (process.env.REACT_APP_SPRING_PROFILES_ACTIVE || '').split(',').indexOf('dev') === -1
